import {
  ChecklistComplementaryItemPosition,
  checklistComplementaryItems,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.ComplementaryItemsConstant';
import { Form, Table, Typography } from 'antd';
import complementItemsColumns from '../complementItemsColumns';
import {
  ChecklistComplementItemFields,
  ChecklistComplementItemResponse,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';

const ChecklistComplementItemsLiftList: React.FC = () => {
  const form = Form.useFormInstance();
  const items = Form.useWatch<ChecklistComplementItemFields[]>(
    'items-lift',
    form,
  );

  const complementItems = checklistComplementaryItems.filter(
    (item) => item.position === ChecklistComplementaryItemPosition.Lift,
  );

  function handleAllCheckbox(
    checked: boolean,
    responseType: ChecklistComplementItemResponse,
  ) {
    form.setFieldValue(
      'items-lift',
      complementItems.map((item) => ({
        response: checked ? [responseType] : [],
        description: item.value,
      })),
    );
  }

  function handleAllSelected(responseType: ChecklistComplementItemResponse) {
    return (
      items?.length > 0 &&
      !!items?.every((item) =>
        item.response?.some((type) => type === responseType),
      )
    );
  }

  function handleAllIndeterminate(
    responseType: ChecklistComplementItemResponse,
  ) {
    return (
      items?.length > 0 &&
      !!items?.some((item) =>
        item.response?.some((type) => type === responseType),
      ) &&
      !items?.every((item) =>
        item.response?.some((type) => type === responseType),
      )
    );
  }

  return (
    <>
      <Typography.Title level={4}>Veículo no elevador</Typography.Title>

      <Form.List name="items-lift">
        {() => (
          <Table
            pagination={false}
            dataSource={complementItems}
            columns={complementItemsColumns({
              listName: 'items-lift',
              handleAllCheckbox,
              handleAllSelected,
              handleAllIndeterminate,
            })}
            scroll={{ x: true }}
          />
        )}
      </Form.List>
    </>
  );
};

export default ChecklistComplementItemsLiftList;
